import { createRoot } from 'react-dom/client'

import App from 'shared/App'
import AppWrapper from 'shared/AppWrapper'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <AppWrapper>
    <App />
  </AppWrapper>
)
